import React from 'react';
import { Reactions } from 'wix-ui-tpa';
import { useTranslate } from '../../../context/api-context/translations/use-translate';
import ReactionIcon from '../reaction-icon/reaction-icon';
import { getReactionKeyByName } from '../utils/get-reaction-key';
import { getReactionCode, getReactionName } from '../utils/reaction-converters';
import { defaultReactionsInMenu, resolveMainReactionName } from '../default-reactions';
import classNames from 'classnames';
import { classes, st } from './reaction-menu.st.css';
import { REACTION_MENU, REACTION_MENU_DATA, HAS_REACTION, REACTION_PENDING, } from '../../../../common/constants/data-hooks';
import { useApi } from '../../../context/api-context/use-api';
import { getIsMobile } from '../../../../common/store/base-params/base-params-selectors';
import { isDefined } from '../../../../ts-utils';
const ReactionMenu = ({ className, activeReaction, onReact, isPending, reactionConfig, }) => {
    const isMobile = useApi(getIsMobile);
    const t = useTranslate();
    const isMainReaction = (reactionName) => reactionName === resolveMainReactionName(reactionConfig.mainEmotion);
    const popoverReactions = [
        ...(reactionConfig.emotions ? reactionConfig.emotions : defaultReactionsInMenu),
    ].filter(isDefined);
    const renderReactionIcon = (reactionName) => {
        const reactionCode = getReactionCode(reactionName, resolveMainReactionName(reactionConfig.mainEmotion));
        return (React.createElement(ReactionIcon, { className: classes.reactionIcon, dataHook: reactionCode, reactionName: reactionName }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Reactions, { "data-hook": REACTION_MENU, className: classNames(st(classes.root, {
                isMobile,
                hasActiveReaction: !!activeReaction,
                isHeartIcon: resolveMainReactionName(reactionConfig.mainEmotion) === 'heart',
            }), className), defaultReaction: resolveMainReactionName(reactionConfig.mainEmotion), popoverTriggerAriaLabel: `${t('reaction-button.aria-label')} ${activeReaction
                ? t('reaction-button.aria-label-has-reaction', {
                    reaction: getReactionKeyByName(getReactionName(activeReaction, resolveMainReactionName(reactionConfig.mainEmotion))),
                })
                : ''}`, onReactionSelect: (reactionName) => {
                if (reactionName) {
                    // select
                    onReact === null || onReact === void 0 ? void 0 : onReact(getReactionCode(reactionName, resolveMainReactionName(reactionConfig.mainEmotion)));
                }
                else if (activeReaction) {
                    // deselect
                    onReact === null || onReact === void 0 ? void 0 : onReact(activeReaction);
                }
                else {
                    // skip as there was nothing selected and nothing deselected.
                }
            }, additionalReactions: popoverReactions, reactionLabel: (reactionName) => isMainReaction(reactionName) ? t('reaction.like') : t(getReactionKeyByName(reactionName)), reactionIcon: renderReactionIcon, selectedId: activeReaction
                ? getReactionName(activeReaction, resolveMainReactionName(reactionConfig.mainEmotion))
                : undefined }),
        React.createElement("span", { "data-hook": `${REACTION_MENU_DATA} ${activeReaction ? HAS_REACTION : ''} ${isPending ? REACTION_PENDING : ''}`, "aria-hidden": "true" })));
};
export default ReactionMenu;
//# sourceMappingURL=reaction-menu.js.map